var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTariffCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 691.57 255.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a3cfd9;}.cls-2{fill:#ecf2f1;}.cls-3{fill:#338598;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 340.78,
    y: -198.26,
    width: 10,
    height: 712.85,
    transform: "translate(104.22 451.8) rotate(-75.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -9.83,
    y: 153.99,
    width: 708.06,
    height: 10,
    transform: "translate(-29.34 94.04) rotate(-14.93)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "262.49 113.86 307.25 99.59 422.97 115.73 431.89 190.24 313.81 190.24 254.78 190.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M281,190.23h26.23V99.59L281,107.87Zm6.56-49.2h0a3.28,3.28,0,1,1,6.56,0v9.84a3.28,3.28,0,1,1-6.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M435.12,117.6a3.22,3.22,0,0,0-1.33-2.19L347.25,53.59a13,13,0,0,0,2.48-19.73L356.37,4h0a3.28,3.28,0,0,0-3.2-4H326.93a3.28,3.28,0,0,0-3.2,4l6.64,29.87a13,13,0,0,0,2.71,19.85l-80.3,61.76a3.17,3.17,0,0,0-1.08,1.67l-.2.06V187a3.28,3.28,0,0,0,3.28,3.28h19.68V110l-6.34,2L331,63.57,314.14,98.3a3.4,3.4,0,0,0-.33,1.43v90.51H431.89a3.28,3.28,0,0,0,3.28-3.28V117.62ZM267.89,154.15a3.28,3.28,0,1,1-6.56,0v-9.84a3.28,3.28,0,1,1,6.56,0Zm91.44-83.87L423,115.73l-29.14-4.48ZM384,109.74,320.6,100l20.2-41.54ZM340.05,36.08A6.59,6.59,0,1,1,335.42,38a6.56,6.56,0,0,1,4.63-1.93Zm-3.28,144.31a3.28,3.28,0,1,1-6.56,0V111.52a3.28,3.28,0,1,1,6.56,0Zm16.4,0a3.28,3.28,0,0,1-6.56,0V114.8a3.28,3.28,0,0,1,6.56,0Zm16.4,0a3.28,3.28,0,1,1-6.56,0V118.08a3.28,3.28,0,1,1,6.56,0Zm16.4,0h0a3.28,3.28,0,0,1-6.56,0v-59a3.28,3.28,0,0,1,6.56,0Zm16.4,0h0a3.28,3.28,0,0,1-6.56,0V124.64a3.28,3.28,0,0,1,6.56,0Zm16.4,0h0a3.28,3.28,0,1,1-6.56,0V127.92a3.28,3.28,0,1,1,6.56,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481,225.6l-16.27-30.74a4,4,0,0,0-3.18-2.12l-12-1.13a20.31,20.31,0,0,0-2.42-8.71,19.41,19.41,0,0,0-6.51-7.34c-3-1.89-5.91-2.19-8.33-.91s-3.78,3.94-3.94,7.42a19.86,19.86,0,0,0,2.43,9.54,20.4,20.4,0,0,0,5.83,6.89l-5.83,10.59a3.93,3.93,0,0,0,0,3.87l16.35,30.73a4,4,0,0,0,5.45,1.66l26.79-14.3A4,4,0,0,0,481,225.6Zm-46-36.34a14.21,14.21,0,0,1-1.89-7c.07-1.59.53-2.8,1.29-3.18a1.52,1.52,0,0,1,.83-.23,5.32,5.32,0,0,1,2.57.91,14.69,14.69,0,0,1,4.85,5.53,15.13,15.13,0,0,1,1.81,5.9l-1.06-.07a4,4,0,0,0-3.93,2.12l-.53,1a15.67,15.67,0,0,1-3.94-4.92ZM464,230.14a.61.61,0,0,1-.23.83l-2.65,1.36a.61.61,0,0,1-.83-.22l-1.44-2.65a6.18,6.18,0,0,1-7.72-2.2.55.55,0,0,1,.23-.83L454,225a.5.5,0,0,1,.68.15,2.06,2.06,0,0,0,2.57.53l2.35-1.21a3.14,3.14,0,0,0,1.51-3.86,3,3,0,0,0-4.16-1.51l-1.74.9a7.32,7.32,0,0,1-9.54-2.19,7.14,7.14,0,0,1,1.74-9.76l-1.29-2.73a.61.61,0,0,1,.23-.83l2.65-1.37a.61.61,0,0,1,.83.23l1.44,2.65a6.17,6.17,0,0,1,7.72,2.2.61.61,0,0,1-.22.83l-2.65,1.44a.51.51,0,0,1-.69-.15,2.06,2.06,0,0,0-2.57-.53L450.47,211a3.1,3.1,0,0,0-1.51,3.86,3,3,0,0,0,4.16,1.51l2-1.06a7.14,7.14,0,0,1,10,3.63,7.26,7.26,0,0,1-2.49,8.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariffCover);
export default __webpack_public_path__ + "static/media/Tariff-cover.559b64b0c32f42c9e4e1d5320014ef2e.svg";
export { ForwardRef as ReactComponent };